"use client";

import { c as _c } from "react/compiler-runtime";
import type { CategoryEnum } from "@sprawdzonabron/shared";
import { useSyncFilters } from "./hooks";
export const FiltersSync = t0 => {
  const $ = _c(5);
  const {
    defaultCategory,
    defaultSearch,
    defaultProducer,
    defaultCity
  } = t0;
  let t1;
  if ($[0] !== defaultCategory || $[1] !== defaultCity || $[2] !== defaultProducer || $[3] !== defaultSearch) {
    t1 = {
      defaultCategory,
      defaultSearch,
      defaultProducer,
      defaultCity
    };
    $[0] = defaultCategory;
    $[1] = defaultCity;
    $[2] = defaultProducer;
    $[3] = defaultSearch;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useSyncFilters(t1);
  return null;
};